import { render } from "./shipDateRenderer.vue?vue&type=template&id=027d9a9b"
import script from "./shipDateRenderer.vue?vue&type=script&lang=js"
export * from "./shipDateRenderer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__